<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialogStandardImport"
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('standard_import_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="standard.valid" lazy-validation>
            <v-text-field outline :rules="idRules" v-model="standard.id" :label="$t('id_label')"></v-text-field>
            <v-text-field
              outline
              :rules="nameRules"
              v-model="standard.name"
              :label="$t('name_label')"
              required
            ></v-text-field>
            <v-textarea
              outline
              :rules="descRules"
              v-model="standard.desc"
              :label="$t('description_label')"
              required
            ></v-textarea>
            <v-textarea
              outline
              :rules="chapterRules"
              v-model="chapters"
              :placeholder="$t('chapters_placeholder')"
              :label="$t('chapters_label')"
              required
            ></v-textarea>

            <vue-csv-import
              v-model="chapters_csv"
              :map-fields="['id','description']"
              :label="$t('csv_import')"
            ></vue-csv-import>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.native="importStandard">{{ $t('import_standard') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
  {
    "de": {
      "standard_import_title" : "Standard Import",
      "name_label" : "Name",
      "id_label" : "Id (optional)",
      "import_standard" : "Importieren",
      "description_label" : "Beschreibung",
      "chapters_label" : "Kapitel Struktur",
      "chapters_placeholder" : "JSON [\n { \"id\" : \"1.0\", \"description\" : \"Kapitel 1\",\n ...\n]\noder CSV:\n\"1.0\";\"Kapitel 1\"",
      "field_required" : "Feld darf nicht leer sein",
      "csv_import" : "CSV-Import"
    },
    "en": {
      "standard_import_title" : "Standard Import",
      "name_label" : "Name",
      "id_label" : "Id (optional)",
      "import_standard" : "Import",
      "description_label" : "Description",
      "chapters_label" : "Chapter structure",
      "chapters_placeholder" : "JSON [\n { \"id\" : \"1.0\", \"description\" : \"Kapitel 1\",\n ...\n]\noder CSV:\n\"1.0\";\"Kapitel 1\"",
      "field_required" : "No empty field allowed",
      "csv_import" : "CSV-Import"
    }
  }
</i18n>

<script>
import { mapActions } from "vuex";
import { api } from "@/store/modules/standards";
import VueCsvImport from "vue-csv-import";
import uuid from "uuid";

function ChaptersToCsv(Chapters) {
  let lines = '"id";"description"';
  for (let Chapter of Chapters) {
    lines +=
      '\n"' +
      Chapter.id.replace("\\", "\\\\").replace('"', '\\"') +
      '";"' +
      Chapter.description.replace("\\", "\\\\").replace('"', '\\"') +
      '"';
    console.log(Chapter);
  }

  return lines;
}

function normalizeChapters(Chapters) {
  return Chapters.map(Chapter => {
    return {
      id: Chapter.id.trim(),
      description: Chapter.description.trim()
    };
  });
}
function validateChapters(chapters) {
  console.log("Validate Chapters", typeof chapters);
  if (!(chapters instanceof Array)) {
    throw "root must be an array";
  }
  if (chapters.length < 1) {
    throw "at least one chapter required";
  }

  for (let chapter of chapters) {
    if (typeof chapter.id !== "string") {
      throw "id must be a string";
    }
    if (typeof chapter.description !== "string") {
      throw "description must be a string";
    }
  }
}

export default {
  components: { VueCsvImport },
  props: {
    dialogStandardImport: {
      default: false
    }
  },
  data: () => ({
    nameRules: [
      v => !!v || "Name is required",
      v =>
        (v && 2 <= v.trim().length && v.trim().length <= 32) ||
        "Name length invalid 2-32 Characters"
    ],
    idRules: [
      v =>
        (2 <= v.trim().length && v.trim().length <= 32) ||
        v.trim().length == 0 ||
        "Id length invalid 2-32 Characters",
      v =>
        /^([A-Z][A-Z0-9\-_]{1,31})?$/i.test(v.trim()) ||
        "Id must start with a letter followed by digiest or letters"
    ],
    descRules: [
      v => !!v || "Description is required",
      v =>
        (v && 5 <= v.trim().length && v.trim().length <= 256) ||
        "Description length invalid 5-256 Characters"
    ],
    chapterRules: [
      v => {
        try {
          let chapters = JSON.parse(v);

          validateChapters(chapters);
        } catch (e) {
          if (typeof e === "object") {
            return e.message;
          } else {
            return e;
          }
        }
        return true;
      }
    ],
    editStandard: {
      id: "",
      name: "",
      desc: "",
      isJson: true,
      valid: false,
      chapters: null
    }
  }),
  computed: {
    standard() {
      return this.editStandard;
    },
    chapters: {
      get() {
        if (this.editStandard.chapters === null) {
          return "";
        } else if (this.editStandard.isJson) {
          return JSON.stringify(this.editStandard.chapters, undefined, 2);
        } else {
          return ChaptersToCsv(this.editStandard.chapters);
        }
      },
      set(value) {
        this.editStandard.valid = false;

        try {
          this.editStandard.chapters = JSON.parse(value);
          this.editStandard.isJson = true;
          validateChapters(this.editStandard.chapters);
          this.editStandard.chapters = normalizeChapters(
            this.editStandard.chapters
          );
          this.editStandard.valid = true;
        } catch (e) {
          console.log(e);
          this.editStandard.valid = false;
        }
      }
    },
    chapters_csv: {
      get() {
        return this.editStandard.chapters;
      },
      set(value) {
        this.editStandard.valid = false;

        try {
          this.editStandard.chapters = value;
          validateChapters(this.editStandard.chapters);
          this.editStandard.chapters = normalizeChapters(
            this.editStandard.chapters
          );
          this.editStandard.valid = true;
        } catch (e) {
          console.log(e);
          this.editStandard.valid = false;
        }
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.importStandards]),
    close() {
      this.$emit("update:dialogStandardImport", false);

      console.log("Schließen");
    },
    importStandard() {
      if (this.$refs.form.validate()) {
        const payload = {
          data: {
            id:
              this.editStandard.id.trim().length != 0
                ? this.editStandard.id.trim()
                : uuid.v4(),
            name: this.editStandard.name.trim(),
            description: this.editStandard.desc.trim(),
            chapters: this.editStandard.chapters
          }
        };

        this.importStandards(payload)
          .then(success => {
            console.log("ImportData: OK", success);
            this.close();
          })
          .catch(reason => {
            console.log("ImportData: Failed", reason);
          });
      } else {
        console.log("ImportData: Invalid");
      }
    }
  }
};
</script>
